import { AnalyticsService } from "./AnalyticsService";

const notificationAnalytics = new AnalyticsService("Alert");

export default notificationAnalytics;
